module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-vanishing-cousins-cropped.b162894e.jpg";